<template>
  <v-card
    class="d-flex flex-column"
    style="height: calc(100vh - 80px); overflow: hidden"
  >
    <v-progress-linear
      :active="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>

    <v-card-title v-if="!loading">
      <!-- Fila con los 4 filtros de búsqueda -->
      <v-row class="w-100" no-gutters>
        <v-col cols="12" md="3" class="pr-2">
          <v-text-field
            v-model="filtroNombre"
            label="Buscar por Nombre"
            single-line
            hide-details
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" class="pr-2">
          <v-select
            v-model="filtroDeviceType"
            :items="deviceTypeOptions"
            label="Tipo de dispositivo"
            item-title="title"
            item-value="value"
            clearable
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" md="3" class="pr-2">
          <v-text-field
            v-model="filtroLocation"
            label="Buscar por Localización"
            single-line
            hide-details
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="filtroReader"
            label="Buscar por Reader"
            single-line
            hide-details
            dense
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- Fila para el selector de columnas -->
      <v-row class="w-100 mt-2" no-gutters>
        <v-col cols="12" md="4">
          <v-select
            v-model="selectedColumns"
            :items="columnOptions"
            item-title="text"
            item-value="value"
            label="Seleccionar columnas"
            multiple
            dense
            outlined
          >
            <template #selection="{ index }">
              <span v-if="index === 0">Seleccionar columnas</span>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card-title>

    <v-data-table
      v-if="!loading"
      id="inventory-table"
      :headers="filteredHeaders"
      :items="datosParaTabla"
      v-model:page="page"
      v-model:items-per-page="itemsPerPage"
      class="elevation-1 flex-grow-1"
      fixed-header
      hide-default-footer
      item-value="Id"
      v-model="selectedDevices"
      show-select
      style="overflow: hidden"
    >
      <!-- Renderizamos cada columna solo si está seleccionada -->
      <template v-if="isColumnVisible('Name')" #[`item.Name`]="{ item }">
        <span
          :class="itemClass(item)"
          style="display: block; width: 100%; height: 100%"
        >
          {{ item.Name }}
        </span>
      </template>
      <template
        v-if="isColumnVisible('statusKey')"
        #[`item.statusKey`]="{ item }"
      >
        <span
          :class="itemClass(item)"
          style="display: block; width: 100%; height: 100%"
        >
          {{ item.statusKey }}
        </span>
      </template>
      <template
        v-if="isColumnVisible('LOCATION')"
        #[`item.LOCATION`]="{ item }"
      >
        <span
          :class="itemClass(item)"
          style="display: block; width: 100%; height: 100%"
        >
          {{ item.LOCATION }}
        </span>
      </template>
      <template v-if="isColumnVisible('Reader')" #[`item.Reader`]="{ item }">
        <span
          :class="itemClass(item)"
          style="display: block; width: 100%; height: 100%"
        >
          {{ item.Reader }}
        </span>
      </template>
      <template v-if="isColumnVisible('updated')" #[`item.updated`]="{ item }">
        <span
          :class="itemClass(item)"
          style="display: block; width: 100%; height: 100%"
        >
          {{ item.updated }}
        </span>
      </template>

      <!-- Slot inferior: paginación y acciones -->
      <template #bottom>
        <!-- Versión para pantallas pequeñas -->
        <div class="d-flex d-md-none flex-column w-100 pa-2">
          <v-row class="w-100 d-flex align-center justify-start mb-2 flex-wrap">
            <v-col cols="12" class="mb-2">
              <v-select
                v-model="itemsPerPage"
                :items="itemsPerPageOptions"
                item-title="title"
                item-value="value"
                label="Filas por página"
                hide-details
                dense
                outlined
                style="max-width: 250px; min-width: 200px"
              ></v-select>
            </v-col>
            <v-col cols="12" class="mb-2">
              <v-pagination
                v-model="page"
                :length="pageCount"
                total-visible="3"
              ></v-pagination>
            </v-col>
            <v-col cols="12">
              <span>Total de dispositivos: {{ totalDevices }}</span>
            </v-col>
          </v-row>
          <v-row class="w-100 d-flex align-center justify-end flex-wrap">
            <v-col cols="12" class="d-flex justify-end mb-2">
              <v-btn
                color="error"
                dark
                @click="eliminarDispositivos"
                small
                aria-label="Eliminar Dispositivos"
                :disabled="selectedDevices.length === 0"
              >
                <v-icon left>mdi-delete</v-icon>
                Eliminar Dispositivos
              </v-btn>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                color="success"
                dark
                @click="exportarExcel"
                small
                aria-label="Exportar a Excel"
              >
                <v-icon left>mdi-file-excel</v-icon>
                Exportar a Excel
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <!-- Versión para pantallas grandes -->
        <div
          class="d-none d-md-flex w-100 pa-2 align-center justify-space-between flex-wrap"
        >
          <div class="d-flex align-center flex-wrap">
            <v-select
              v-model="itemsPerPage"
              :items="itemsPerPageOptions"
              item-title="title"
              item-value="value"
              label="Filas por página"
              hide-details
              dense
              outlined
              class="mr-4"
              style="max-width: 250px; min-width: 200px"
            ></v-select>
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="3"
              class="mr-4"
            ></v-pagination>
            <span>Total de dispositivos: {{ totalDevices }}</span>
          </div>
          <div class="d-flex">
            <v-btn
              color="error"
              dark
              @click="eliminarDispositivos"
              class="mr-4"
              small
              aria-label="Eliminar Dispositivos"
              :disabled="selectedDevices.length === 0"
            >
              <v-icon left>mdi-delete</v-icon>
              Eliminar Dispositivos
            </v-btn>
            <v-btn
              color="success"
              dark
              @click="exportarExcel"
              small
              aria-label="Exportar a Excel"
            >
              <v-icon left>mdi-file-excel</v-icon>
              Exportar a Excel
            </v-btn>
          </div>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useDeviceStore } from "@/stores/deviceStore";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import api from "@/services/api";

export default {
  name: "InventoryView",
  setup() {
    const deviceStore = useDeviceStore();
    const loading = ref(true);
    const selectedDevices = ref([]);

    // Filtros vinculados al store
    const filtroNombre = computed({
      get: () => deviceStore.filtroNombre,
      set: (value) => {
        deviceStore.filtroNombre = value;
      },
    });
    const filtroReader = computed({
      get: () => deviceStore.filtroReader,
      set: (value) => {
        deviceStore.filtroReader = value;
      },
    });
    const filtroDeviceType = computed({
      get: () => deviceStore.filtroDeviceType,
      set: (value) => {
        deviceStore.filtroDeviceType = value;
      },
    });
    const filtroLocation = computed({
      get: () => deviceStore.filtroLocation,
      set: (value) => {
        deviceStore.filtroLocation = value;
      },
    });

    // Configuración para selección de columnas
    const columnOptions = [
      { text: "Nombre", value: "Name" },
      { text: "Estado", value: "statusKey" },
      { text: "Localización", value: "LOCATION" },
      { text: "Reader", value: "Reader" },
      { text: "Última Actualización", value: "updated" },
    ];
    // Inicialmente se muestran todas las columnas
    const selectedColumns = ref(columnOptions.map((col) => col.value));

    // Headers de la tabla (incluye la columna de selección)
    const headers = [
      { title: "", value: "select", sortable: false },
      { title: "Nombre", value: "Name", sortable: true },
      { title: "Estado", value: "statusKey", sortable: true },
      { title: "Localización", value: "LOCATION", sortable: true },
      { title: "Reader", value: "Reader", sortable: true },
      { title: "Última Actualización", value: "updated", sortable: true },
    ];
    // Filtrar headers según las columnas seleccionadas
    const filteredHeaders = computed(() => {
      const base = [headers[0]]; // siempre incluye columna de selección
      const cols = headers
        .slice(1)
        .filter((h) => selectedColumns.value.includes(h.value));
      return base.concat(cols);
    });
    // Helper para saber si se muestra la columna
    const isColumnVisible = (colValue) =>
      selectedColumns.value.includes(colValue);

    const itemsPerPage = ref(10);
    const page = ref(1);
    const itemsPerPageOptions = [
      { title: "10", value: 10 },
      { title: "20", value: 20 },
      { title: "50", value: 50 },
      { title: "100", value: 100 },
      { title: "500", value: 500 },
      { title: "1000", value: 1000 },
    ];

    const datosParaTabla = computed(() =>
      deviceStore.devicesFiltrados.map((device) => ({
        ...device,
        LOCATION: device.Location || "Sin ubicación",
      }))
    );

    const itemClass = (item) => {
      if (!item.updated) return "";
      const lastUpdate = new Date(item.updated);
      const diffDays = (Date.now() - lastUpdate) / (1000 * 60 * 60 * 24);
      return diffDays > 3 ? "highlight-red" : "";
    };

    const pageCount = computed(() => {
      if (itemsPerPage.value === -1) return 1;
      return Math.ceil(datosParaTabla.value.length / itemsPerPage.value);
    });
    const totalDevices = computed(() => datosParaTabla.value.length);

    const exportarExcel = async () => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Inventario");
      worksheet.columns = filteredHeaders.value.map((header) => ({
        header: header.title,
        key: header.value,
        width: 20,
      }));
      datosParaTabla.value.forEach((device) => {
        const rowData = {};
        filteredHeaders.value.forEach((h) => {
          if (h.value === "select") return;
          rowData[h.value] = device[h.value];
        });
        worksheet.addRow(rowData);
      });
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), "Inventario.xlsx");
    };

    const eliminarDispositivos = async () => {
      if (selectedDevices.value.length === 0) {
        alert("Selecciona al menos un dispositivo para eliminar.");
        return;
      }
      try {
        const result = await api.deleteDevices(selectedDevices.value);
        const idsEliminados = result.resultados
          .filter((r) => r.status === "success")
          .map((r) => r.id);
        deviceStore.devices = deviceStore.devices.filter(
          (device) => !idsEliminados.includes(device.id)
        );
        selectedDevices.value = [];
        alert("Dispositivos eliminados correctamente");
      } catch (error) {
        if (error.status === 403) {
          alert(
            "No tienes permisos de administrador para eliminar dispositivos."
          );
        } else {
          alert(`Error al eliminar dispositivos: ${error.message}`);
        }
      }
    };

    onMounted(async () => {
      if (!deviceStore.devices.length) {
        await deviceStore.fetchDevices();
      }
      if (deviceStore.filtroFamily) {
        filtroNombre.value = deviceStore.filtroFamily[0];
        deviceStore.filtroFamily = [];
      }
      // deviceStore.startPeriodicUpdate();
      // Asignación de deviceTypeOptions para el select de "Tipo de dispositivo"
      const deviceTypeTitles = {
        54: "Reader",
        55: "Beacon/Tracker",
        64: "Smart Beacon/Tracker",
      };
      const options = [];
      deviceStore.devices.forEach((d) => {
        if (
          d.DeviceType !== undefined &&
          d.DeviceType !== null &&
          !options.includes(d.DeviceType)
        ) {
          options.push(d.DeviceType);
        }
      });
      // Se transforma a formato { title, value }
      deviceTypeOptions.value = options.map((type) => ({
        title: deviceTypeTitles[type] || `Tipo ${type}`,
        value: type,
      }));
      loading.value = false;
    });

    // deviceTypeOptions para el select de tipo de dispositivo
    const deviceTypeOptions = ref([]);

    return {
      loading,
      filtroNombre,
      filtroDeviceType,
      filtroLocation,
      filtroReader,
      deviceTypeOptions,
      selectedColumns,
      columnOptions,
      filteredHeaders,
      isColumnVisible,
      itemsPerPage,
      page,
      itemsPerPageOptions,
      datosParaTabla,
      itemClass,
      pageCount,
      totalDevices,
      exportarExcel,
      eliminarDispositivos,
      selectedDevices,
    };
  },
};
</script>

<style>
th {
  color: black !important;
}
.pa-2 {
  padding: 0.5rem;
}
.highlight-red {
  background-color: #ffcccc !important;
  color: black !important;
}
.button-group {
  display: flex;
  justify-content: end;
  gap: 10px;
}
@media (max-width: 600px) {
  .text-right {
    text-align: center !important;
  }
  .mr-4 {
    margin-right: 0 !important;
    margin-bottom: 0.5rem !important;
  }
}
#inventory-table table {
  border-collapse: collapse !important;
}
#inventory-table td {
  padding: 0 !important;
  border: none !important;
}
#inventory-table td .highlight-red {
  background-color: #ffcccc !important;
  color: black !important;
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
#inventory-table tbody tr:has(.highlight-red) td {
  background-color: #ffcccc !important;
}
</style>
